import TitleSection from "../components/TitleSection";
import DataPartners from "../components/DataPartners";
import data from "../../../datasets/usecases/leadtargeting";
import Recipes from "../components/Recipes";
// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";

export const LeadTargeting = () => {
  return (
    <div className="lead_targeting">
      <TitleSection data={data} />
      <Recipes data={data} />
      <DataPartners dataPartners={data.dataPartners} />
      {/* <PricingGetStarted /> */}
    </div>
  );
};
